export const LandingFooter = () => {
  return (
    <footer id="about" className="mt-24 border-t border-border/60 bg-card/40">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <span className="text-xl font-bold tracking-tight text-foreground">
              Jou<span className="text-emerald-600">Rex</span>
            </span>
            <span className="text-xs text-muted-foreground ml-2">
              © {new Date().getFullYear()} JouRex. All rights reserved.
            </span>
          </div>
          <div className="flex items-center gap-6 text-sm text-muted-foreground">
            <a href="/terms" className="hover:text-foreground transition-colors">Terms</a>
            <a href="/privacy" className="hover:text-foreground transition-colors">Privacy</a>
            <a href="/refund" className="hover:text-foreground transition-colors">Refund</a>
            <a href="/pricing" className="hover:text-foreground transition-colors">Pricing</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
